import apiClient from '../utils/apiClient';

export interface DataProviderInputMappingColumnsModel{
  id: number;
  inputMappingId: number;
  destinationColumn: string;
  inputColumn: string;
  transformFunction?: string | null;
  description: string | null;
}

export const getDataProviderInputMappingColumns = async (name: string) : Promise<DataProviderInputMappingColumnsModel[]> => {
    return await apiClient.get<DataProviderInputMappingColumnsModel[]>(`api/DataProviderInputMappingColumns?name=${name}`);
};
